/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsScheduleRecommendationResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsScheduleRecommendationResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsScheduleRecommendationResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsScheduleRecommendationResource>): RecommendationForFinopsScheduleRecommendationResource {
        let obj = Object.assign(new RecommendationForFinopsScheduleRecommendationResource(), model);
        RecommendationForFinopsScheduleRecommendationResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsScheduleRecommendationResource>): RecommendationForFinopsScheduleRecommendationResource {
        if (!model) return null;
        return RecommendationForFinopsScheduleRecommendationResource.newInstance(<RecommendationForFinopsScheduleRecommendationResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsScheduleRecommendationResource) {
        if (!obj) return;

        models.RecommendationForFinopsScheduleRecommendationResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsScheduleRecommendationResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsScheduleRecommendationResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
